import React from 'react';
import { CustomizedTypography } from '@components/Customized';
import useStyles from './useStyles';

const ChatEmptyPresenter: React.FC = () => {
  const classes = useStyles();

  return (
    <div className={classes['Chat-Empty-root']}>
      <CustomizedTypography variant="h4" fontWeight="normal" align="center">
        파트너와 채팅하고
        <br />
        프로젝트를 발주해보세요
      </CustomizedTypography>
    </div>
  );
};

export default ChatEmptyPresenter;
